import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Ringing from "../pages/adminPortal/chatsytem/Ringing";
import chatService from "../services/chat-service";

const GlobalRingingListener = ({ user }) => {
  const navigate = useNavigate();
  
  const [incomingQueue, setIncomingQueue] = useState([]);
    const [error, setError] = useState("");

  /* Add chat to ringing queue (no duplicates) */
  const enqueueChat = useCallback((chat) => {
    if (!chat?.id) return;

    setIncomingQueue((prev) => {
      if (prev.some((c) => c.id === chat.id)) return prev;
      return [...prev, chat];
    });
  }, []);

  /*Echo listeners*/
  useEffect(() => {
    if (!user?.id || !user?.role_id || !window.Echo) return;

    // Department channel
    const departmentChannel = window.Echo.private(
      `department.${user.role_id}`
    );

    // New customer chat
    departmentChannel.listen(".new-chat-request", (e) => {
      if (!e?.chatRequest) return;
      console.log("new");
      enqueueChat({
        ...e.chatRequest,
        __ringReason: "new",
      });
    });

    // Department transfer (no specific agent)
    departmentChannel.listen(".chat-transferred", (e) => {
      if (!e?.assigned_agent_id) {
        enqueueChat({
          id: e.chat_id,
          __ringReason: "transfer",
        });
      }
    });

    // agent channel
    const userChannel = window.Echo.private(`user.${user.id}`);

    userChannel.listen(".chat-transferred", (e) => {
      if (e?.assigned_agent_id === user.id) {
        enqueueChat({
          id: e.chat_id,
          __ringReason: "transfer",
        });
      }
    });

    // Cleanup
    return () => {
      window.Echo.leave(`department.${user.role_id}`);
      window.Echo.leave(`user.${user.id}`);
    };
  }, [user?.id, user?.role_id, enqueueChat]);

  /* Currently ringing chat (FIFO)*/
  const incomingChat = incomingQueue[0] || null;

  /* Accept chat */
  const acceptChat = async () => {
    if (!incomingChat?.id) return;

    try {
     const acceptresponse =  await chatService.accept(incomingChat.id);

      // Remove this chat from queue
        setIncomingQueue((prev) => prev.slice(1));
     if(acceptresponse.success == false){
          setError(acceptresponse?.message || "Chat already accepted");
     }
      

      navigate("/chat");
    } catch (err) {
         console.log(err);
         setError(err?.message || "Chat already accepted");
      
    }
  };

  /* Mute chat for 15 minutes */
  const muteChat = async () => {
    if (!incomingChat?.id) return;

    try {
      await chatService.mute(incomingChat.id);

      // Remove only this chat from queue
      setIncomingQueue((prev) => prev.slice(1));
    } catch (err) {
      console.error("Mute chat failed", err);
    }
  };

  /* Stop rendering if no chat */
  if (!incomingChat) return null;

  /* Mute check */
  const isMuted =
    incomingChat.muted_until &&
    new Date(incomingChat.muted_until) > new Date();

  if (isMuted) return null;

  return (
    <>
      <Ringing
        incomingChat={incomingChat}
        onAccept={acceptChat}
        onMute={muteChat}
      />

      
         {error && (
              <div
                style={{
                  position: "fixed",
                  top: 20,
                  right: 20,
                  zIndex: 9999,
                }}
                className="alert alert-danger"
              >
                {error}
              </div>
         )}
    </>
  );
};

export default GlobalRingingListener;
